<template>

  <div class="padded">

    <div v-if="!hideTitle" class="dash-heading"><i class="fa fa-tower-cell" />&nbsp;Tower Suppliers Report</div>

    <el-row>
      <el-col v-if="canAccess('finance|management')" :sm="24" :md="12">
        <br />
        <h4>Total Rates</h4>

        <pie-chart :data="rateChart"
        :donut="true"
        thousands=","
        legend="" />

        <br />
      </el-col>

      <el-col :sm="24" :md="12">
        <br />
        <h4>Total Sites</h4>

        <pie-chart :data="siteChart"
        :donut="true"
        thousands=","
        legend="left" />

        <br />
      </el-col>

      <el-col :sm="24" :md="canAccess('finance|management') ? 24 : 12" :lg="canAccess('finance|management') ? 24 : 12">
        <el-table
             :data="list"
             border
             stripe
             show-summary
             sum-text="Totals"
             :summary-method="summaryFormatter"
             style="width: 100%">

             <el-table-column prop="towerSupplier"
              label="Tower Supplier">

              <template slot-scope="scope">
                 <sites-popup :name="scope.row.towerSupplier" :supplier-id="scope.row.supplier_id" :status="scope.row.status" />
             </template>

             </el-table-column>


             <el-table-column prop="status"
              label="Site Status">
             </el-table-column>

             <el-table-column prop="sites"
             label="Sites"
              sortable
              align="right"
              :formatter="formatInt">
             </el-table-column>

             <el-table-column
                v-if="canAccess('finance|management') || isTowerSupplierCo()"
                prop="totalRates"
                label="Total Rates"
                sortable
                align="right"
                :formatter="formatNum">
             </el-table-column>

             <el-table-column
                v-if="canAccess('finance|management') || isTowerSupplierCo()"
                prop="capex"
                label="CAPEX"
                sortable
                align="right"
                :formatter="formatNum">
             </el-table-column>

             <el-table-column
                v-if="canAccess('finance|management') || isTowerSupplierCo()"
                prop="opex"
                label="OPEX"
                sortable
                align="right"
                :formatter="formatNum">
             </el-table-column>

        </el-table>
      </el-col>

    </el-row>

  </div>

</template>


<script>

import PostMixins from '@/mixins/PostMixins'
import ElTableMixins from '@/mixins/ElTableMixins'
import NumberMixins from '@/mixins/NumberMixins'

import SitesPopup from '@/components/dashboard/sites/SitesPopup'


export default {
  mixins: [PostMixins, ElTableMixins, NumberMixins],

  components: {
    SitesPopup
  },

  props: {
    hideTitle: {
      type: Boolean,
      default: false
    }
  },

  methods: {

    successReport (data) {
      this.list = data

      for (var i = 0; i < this.list.length; i++) {
        this.rateChart.push([this.list[i].towerSupplier + ' | ' + this.list[i].status.toUpperCase(), Number(Number(this.list[i].totalRates).toFixed(2))])
        this.siteChart.push([this.list[i].towerSupplier + ' | ' + this.list[i].status.toUpperCase(), Number(this.list[i].sites)])
      }

    },

    summaryFormatter (param) {
      return this.totalColumns(param, 'Totals', ['sites'], ['totalRates', 'capex', 'opex'])
    }

  },



  data () {
    return {
      list: [],
      rateChart: [],
      siteChart: []
    }

  },

  created () {
    this.fetchData('/report/tower-supplier', this.successReport, 'Tower Suppliers Report')
  }

}

</script>
